import { SiteShift } from 'shiftNotes/_types';

export default function getShiftContributors(shift: SiteShift): string[] {
  const names = shift.shift_notes
    .map((note) =>
      note.user?.first_name
        ? `${note.user.first_name} ${note.user.last_name}`
        : null
    )
    .filter((name): name is string => name !== null);

  return Array.from(new Set(names));
}
